export default __webpack_public_path__ + "static/media/1145.759b443e.png";